import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accountId"];
import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import { useGetPortalTeamsQuery } from '../../../../__generated__/chirp/com/hubspot/learning/center/assignments/rpc/PortalChirpService.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
function convertTeamsToOptions(teams) {
  return teams.map(team => {
    const hasChildren = team.childTeams && team.childTeams.length > 0;
    if (hasChildren) {
      return {
        text: team.teamName,
        selectAll: true,
        options: [{
          text: team.teamName,
          value: team.teamId.toString()
        }, ...convertTeamsToOptions(team.childTeams)]
      };
    }
    return {
      text: team.teamName,
      value: team.teamId.toString()
    };
  });
}
export const TeamsSelect = _ref => {
  let {
      accountId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    data,
    loading
  } = useGetPortalTeamsQuery({
    variables: {
      targetPortalId: accountId || 0
    },
    skip: !accountId
  });
  const teamOptions = useMemo(() => {
    if (!(data !== null && data !== void 0 && data.teams)) return [];
    return convertTeamsToOptions(data.teams);
  }, [data === null || data === void 0 ? void 0 : data.teams]);
  const hasNoTeams = !loading && teamOptions.length === 0 && Boolean(accountId);
  return /*#__PURE__*/_jsx(Select, Object.assign({}, props, {
    anchorType: "button",
    disabled: hasNoTeams || Boolean(props.disabled),
    isLoading: loading,
    multi: true,
    options: teamOptions,
    placeholder: hasNoTeams ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlists.noTeamsInAccount"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlists.selectTeamsPlaceholder"
    })
  }));
};